import http from "./httpService";
import { stringify } from "query-string";
import { getMonitoringJwt } from "./authService";
const apiEndpoint = process.env.REACT_APP_API_URL + "/reportings";

http.setJwt(getMonitoringJwt()!);

export const getData = async (
  pageNumber?: number,
  perimeter?: string,
  institutionId?: string,
  event?: string,
  status?: string,
  startDate?: string,
  endDate?: string
) => {
  http.setJwt(getMonitoringJwt()!);
  const params = {
    pageNumber,
    perimeter,
    institutionId,
    event,
    status,
    startDate,
    endDate,
  };
  const query = stringify(params, { skipEmptyString: true });
  const { data } = await http.get(`${apiEndpoint}?${query}`);
  return data;
};

export const getFormData = async (formName: string, formId: number) => {
  http.setJwt(getMonitoringJwt()!);
  const { data } = await http.get(
    `${process.env.REACT_APP_API_URL}/${formName}/${formId}`
  );
  return data;
};

export const getSingleReporting = async (reportingId: string) => {
  http.setJwt(getMonitoringJwt()!);
  const { data } = await http.get(
    `${process.env.REACT_APP_API_URL}/reportings/${reportingId}`
  );
  return data;
};

export const closeReporting = async (
  reportingId: string,
  params?: { status: string }
) => {
  http.setJwt(getMonitoringJwt()!);
  const { data } = await http.put(
    `${process.env.REACT_APP_API_URL}/reportings/${reportingId}`,
    params
  );
  return data;
};

export default getData;
